import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type AbilitiesService from 'ember-can/services/abilities';
import ManageAdminUsersSingleDeleteRoute from 'garaje/pods/manage/admin-users/single-delete/route';
import type SkinnyLocationsService from 'garaje/services/skinny-locations';
import throwUnlessTaskDidCancel from 'garaje/utils/throw-unless-task-did-cancel';

class LocationOverviewAdminsSingleDeleteRoute extends ManageAdminUsersSingleDeleteRoute {
  @service declare abilities: AbilitiesService;
  @service declare router: RouterService;
  @service declare skinnyLocations: SkinnyLocationsService;

  controllerName = 'manage/admin-users/single-delete';
  templateName = 'manage/admin-users/single-delete';

  // eslint-disable-next-line @typescript-eslint/no-misused-promises
  async beforeModel(): Promise<void> {
    if (this.abilities.cannot('visit global-admin')) {
      void this.router.transitionTo('unauthorized');
    }
    await this.skinnyLocations.loadAllTask.perform().catch(throwUnlessTaskDidCancel);
  }
}

export default LocationOverviewAdminsSingleDeleteRoute;
